import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";

import logo from "assets/images/mail-icon.svg";
import { pathGenerators } from "utils/routes";

import { Common } from "../components/Common/Common";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Must be a valid email")
    .max(255)
    .required("Email is required"),
  password: Yup.string()
    .max(255)
    .min(6, "Password must be at least 6 characters long")
    .required("Password is required"),
  passwordConfirmation: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "Passwords must match"
  ),
});

const initialValues = {
  email: "",
  password: "",
  passwordConfirmation: "",
};

const RegistrationPage = () => {
  const navigate = useNavigate();
  const [showpassword, setshowpassword] = useState({
    password: { showPassword: false },
    passwordConfirmation: { showPassword: false },
  });

  const toggleShowPassword = (name) => {
    setshowpassword((prevPasswords) => ({
      ...prevPasswords,
      [name]: {
        ...prevPasswords[name],
        showPassword: !prevPasswords[name].showPassword,
      },
    }));
  };

  return (
    <>
      <section className="log_sec">
        <div className="logwraper">
          <Common />
          <h2>Kinesin My Health</h2>
          <div className="log_wrap">
            <Formik
              initialValues={initialValues}
              onSubmit={() => {}}
              validationSchema={validationSchema}
            >
              {({ errors, touched, isSubmitting }) => (
                <Form className="">
                  <span className="login100-form-title">Create an account</span>

                  <div className="form-floating mb-3">
                    <Field
                      className={"form-control"}
                      type="email"
                      name="email"
                      id="floatingInput"
                      placeholder="name@example.com"
                    />
                    <label htmlFor="floatingInput">Email</label>
                    <div className="inputicon">
                      <img src={logo} alt="" />
                    </div>
                    {errors.email && touched.email && (
                      <div className="errorstext">{errors.email}</div>
                    )}
                  </div>

                  <div className="form-floating mb-3">
                    <Field
                      className={"form-control"}
                      type={
                        showpassword.password.showPassword ? "text" : "password"
                      }
                      name="password"
                      id="floatingPassword"
                      placeholder="Password"
                    />
                    <label htmlFor="floatingPassword">Password</label>
                    <div
                      className="inputicon"
                      onClick={() => toggleShowPassword("password")}
                      onKeyDown={(e) =>
                        e.key === "Enter" && toggleShowPassword("password")
                      }
                      role="button"
                      tabIndex={0}
                    >
                      {showpassword.password.showPassword ? (
                        <i className="eye fas fa-eye-slash"></i>
                      ) : (
                        <i className="eye fa fa-eye" aria-hidden="true"></i>
                      )}
                    </div>
                    {errors.password && touched.password && (
                      <div className="errorstext">{errors.password}</div>
                    )}
                  </div>

                  <div className="form-floating mb-3">
                    <Field
                      className={"form-control"}
                      type={
                        showpassword.passwordConfirmation.showPassword
                          ? "text"
                          : "password"
                      }
                      name="passwordConfirmation"
                      id="floatingPasswordConfirm"
                      placeholder="Password"
                    />
                    <label htmlFor="floatingPasswordConfirm">
                      Confirm New Password
                    </label>
                    <div
                      className="inputicon"
                      onClick={() => toggleShowPassword("passwordConfirmation")}
                      onKeyDown={(e) =>
                        e.key === "Enter" &&
                        toggleShowPassword("passwordConfirmation")
                      }
                      role="button"
                      tabIndex={0}
                    >
                      {showpassword.passwordConfirmation.showPassword ? (
                        <i className="eye fas fa-eye-slash"></i>
                      ) : (
                        <i className="eye fa fa-eye" aria-hidden="true"></i>
                      )}
                    </div>
                    {errors.passwordConfirmation &&
                      touched.passwordConfirmation && (
                        <div className="errorstext">
                          {errors.passwordConfirmation}
                        </div>
                      )}
                  </div>

                  <span className="register_form">
                    <p>Already have an account?</p>
                    <button
                      type="button"
                      className="link-style sign_txt"
                      onClick={() => navigate(pathGenerators.global.home())}
                    >
                      Sign in
                    </button>
                  </span>

                  <div className="container-login100-form-btn">
                    <button
                      className="custom_btn login_btn"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      Sign up
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </section>
    </>
  );
};

export { RegistrationPage };